import React from 'react'
import './Subtitle.css'
export default props => {
    return (
        <div className="subtitle">
            <h6><small>{props.text}</small></h6>
            <hr/>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/views/components/subtitle/Subtitle.js